import { render, staticRenderFns } from "./AddSpark.vue?vue&type=template&id=ed8fe866&scoped=true&"
import script from "./AddSpark.vue?vue&type=script&lang=ts&"
export * from "./AddSpark.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed8fe866",
  null
  
)

export default component.exports